import { AlertCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface Props {
    isZeroToken: boolean;
    onClose: () => void;
}

export default function LowTokenModal({ isZeroToken, onClose }: Props) {
    const navigate = useNavigate();

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4">
                <div className="p-6">
                    <div className="flex items-center gap-3 mb-3">
                        <div className="w-10 h-10 bg-gradient-to-br from-amber-500 to-orange-600 rounded-xl flex items-center justify-center">
                            <AlertCircle className="w-5 h-5 text-white" />
                        </div>
                        <h2 className="text-lg font-bold text-gray-900">
                            {isZeroToken ? 'No Tokens Left' : 'Low Token Balance'}
                        </h2>
                    </div>
                    <p className="text-sm text-gray-700 mb-5">
                        {isZeroToken
                            ? "You don't have any tokens left. Please purchase tokens to continue."
                            : 'Your token balance is low. Please purchase more tokens to continue smoothly.'}
                    </p>
                    <div className="flex gap-3">
                        <button
                            onClick={onClose}
                            className="flex-1 px-4 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={() => { onClose(); navigate('/tokens/purchase'); }}
                            className="flex-1 px-4 py-2.5 text-sm font-medium text-white bg-gradient-to-r from-amber-600 to-orange-600 rounded-lg hover:from-amber-700 hover:to-orange-700"
                        >
                            Buy Tokens
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
